"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientVenuePicker = void 0;
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const i18n_js_1 = __importDefault(require("i18n-js"));
const query_string_1 = __importDefault(require("query-string"));
const material_1 = require("@mui/material");
const PhoneIphone_1 = __importDefault(require("@mui/icons-material/PhoneIphone"));
const Laptop_1 = __importDefault(require("@mui/icons-material/Laptop"));
const localeHelper_1 = require("../../../common/helpers/localeHelper");
const services_1 = require("../../../common/services");
const Loader_1 = __importDefault(require("../../../common/components/Loader/Loader"));
const ClientVenuePickerWrapper = styled_components_1.default.div `
  padding: 16px;
  height: 30vh;
  width: 100%;
  margin: 30vh auto 0 auto;
`;
const InvalidBrandWrapper = styled_components_1.default.div `
  text-align: center;
`;
const sortVenues = (venues) => venues.sort((a, b) => a.title.localeCompare(b.title));
const ClientVenuePicker = (props) => {
    const [initialVenue, setInitialVenue] = (0, react_1.useState)({});
    const [venues, setVenues] = (0, react_1.useState)([]);
    const [value, setValue] = (0, react_1.useState)("");
    const [mode, setMode] = (0, react_1.useState)("interactive");
    const [selectedLocales, setSelectedLocales] = (0, react_1.useState)([]);
    const [invalidBrand, setInvalidBrand] = (0, react_1.useState)(false);
    const [votingEnabled, setVotingEnabled] = (0, react_1.useState)(false);
    const [isLoaded, setIsLoaded] = (0, react_1.useState)(false);
    const { location } = props;
    const queryParams = query_string_1.default.parse(location.search);
    const initialSetup = () => __awaiter(void 0, void 0, void 0, function* () {
        const venueList = yield services_1.apiService.getVenues();
        setTimeout(() => {
            const radioForInteractive = document.getElementById("interactive");
            if (radioForInteractive) {
                radioForInteractive.setAttribute("checked", "true");
            }
        }, 100);
        let venue = venueList[0];
        if (Object.prototype.hasOwnProperty.call(queryParams, "brand")) {
            const initialBrandVenue = venueList.find((currentVenue) => currentVenue.brandSlug === queryParams.brand);
            if (initialBrandVenue) {
                venue = initialBrandVenue;
            }
            else {
                setInvalidBrand(true);
            }
        }
        setInitialVenue(venue);
        setVenues(venueList);
        setValue(venue.slug);
        setIsLoaded(true);
    });
    const handleVenueChange = (event) => {
        const isVotingEnabled = event.target.value.indexOf("-voting") > -1;
        const selectedVenue = venues.find((venue) => venue.slug === event.target.value.replace("-voting", ""));
        if (selectedVenue) {
            setInitialVenue(selectedVenue);
            setVotingEnabled(isVotingEnabled);
            setValue(event.target.value);
        }
    };
    const openWindow = (type, params) => {
        if (!initialVenue) {
            return;
        }
        const { brandSlug, slug } = initialVenue;
        let locales = "";
        // eslint-disable-next-line no-return-assign
        selectedLocales.map((locale) => (locales = `${locales}&locale=${locale}`));
        const newLocation = `/${brandSlug}/${slug}/${votingEnabled ? "voting/" : ""}overview?daysToFetch=3&mode=${mode}${locales}`;
        window.open(newLocation, type, params.join(","));
    };
    const openInPortrait = (event) => {
        event.preventDefault();
        const params = [
            `height=${window.screen.height - 80}`,
            `width=${(window.screen.height - 80) * (1080 / 1920)}`,
        ];
        openWindow("popup_window", params);
    };
    const openInLandscape169Ratio = (event) => {
        event.preventDefault();
        const params = [
            `height=${(window.screen.width - 50) * (1080 / 1920)}`,
            `width=${window.screen.width - 50}`,
        ];
        openWindow("popup_window", params);
    };
    const openInLandscape43Ratio = (event) => {
        event.preventDefault();
        const params = [`height=${748}`, `width=${1004}`];
        openWindow("popup_window", params);
    };
    const handleModeChange = (event) => {
        setMode(event.current.value);
    };
    const renderVenues = () => {
        if (venues.length === 0) {
            return react_1.default.createElement(material_1.MenuItem, null, "Loading venues ...");
        }
        let filteredVenueList = sortVenues(venues).filter((venue) => venue.settings.dsScreensaver);
        if (Object.prototype.hasOwnProperty.call(queryParams, "brand")) {
            const brandFilteredVenueList = filteredVenueList.filter((venue) => venue.brandSlug === queryParams.brand);
            if (brandFilteredVenueList.length > 0) {
                filteredVenueList = brandFilteredVenueList;
            }
        }
        const renderedList = [];
        filteredVenueList.map((venue) => {
            renderedList.push(react_1.default.createElement(material_1.MenuItem, { key: venue.slug, value: venue.slug }, venue.title));
            if (venue.customOptions) {
                if (Object.prototype.hasOwnProperty.call(venue.customOptions, "votingsRollingKnockoutConfigId")) {
                    renderedList.push(react_1.default.createElement(material_1.MenuItem, { key: `${venue.slug}-voting`, value: `${venue.slug}-voting`, "data-voting": true },
                        venue.title,
                        " Voting"));
                }
            }
            return venue;
        });
        return renderedList;
    };
    const handleLocaleChange = (e, locale) => {
        if (e.target.checked) {
            setSelectedLocales([...selectedLocales, locale]);
        }
        else {
            const updatedLocales = selectedLocales.filter((selectedLocale) => selectedLocale !== locale);
            setSelectedLocales(updatedLocales);
        }
    };
    const renderLocaleSelector = () => {
        if (initialVenue) {
            return initialVenue.enabledLocales.map((locale) => (react_1.default.createElement(material_1.FormControlLabel, { key: locale, value: "end", control: react_1.default.createElement(material_1.Checkbox, { onChange: (e) => handleLocaleChange(e, locale) }), label: localeHelper_1.localeNames[locale], labelPlacement: "end" })));
        }
        return react_1.default.createElement(react_1.default.Fragment, null);
    };
    (0, react_1.useEffect)(() => {
        initialSetup();
    }, []);
    if (!isLoaded) {
        return (react_1.default.createElement("div", { className: "overlay" },
            react_1.default.createElement(Loader_1.default, null)));
    }
    if (invalidBrand) {
        return (react_1.default.createElement(ClientVenuePickerWrapper, null,
            react_1.default.createElement(material_1.Grid, { container: true, justifyContent: "center" },
                react_1.default.createElement(InvalidBrandWrapper, null, i18n_js_1.default.t("invalid_url")))));
    }
    return (react_1.default.createElement(ClientVenuePickerWrapper, null,
        react_1.default.createElement(material_1.Grid, { container: true, spacing: 2 },
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.FormControl, { fullWidth: true },
                    react_1.default.createElement(material_1.InputLabel, { id: "select-venue-label" }, "Select venue"),
                    react_1.default.createElement(material_1.Select, { labelId: "select-venue-label", name: "brand-venue", id: "brand-venue", value: value, label: "Select venue", onChange: handleVenueChange }, renderVenues()))),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.FormControl, { component: "fieldset" },
                    react_1.default.createElement(material_1.RadioGroup, { row: true, "aria-label": "interactivity", defaultValue: "interactive", name: "row-radio-buttons-group" },
                        react_1.default.createElement(material_1.FormControlLabel, { value: "interactive", control: react_1.default.createElement(material_1.Radio, { onChange: handleModeChange }), label: "Interactive" }),
                        react_1.default.createElement(material_1.FormControlLabel, { value: "linear", control: react_1.default.createElement(material_1.Radio, { onChange: handleModeChange }), label: "Linear" })))),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 }, "Locales"),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 12 },
                react_1.default.createElement(material_1.FormControl, { component: "fieldset" },
                    react_1.default.createElement(material_1.FormGroup, { "aria-label": "position", row: true }, renderLocaleSelector()))),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 6, md: 3 },
                react_1.default.createElement(material_1.Button, { onClick: openInPortrait, variant: "contained", fullWidth: true, size: "large", startIcon: react_1.default.createElement(PhoneIphone_1.default, null) }, "Portrait")),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 6, md: 3 },
                react_1.default.createElement(material_1.Button, { onClick: openInLandscape169Ratio, variant: "contained", fullWidth: true, size: "large", startIcon: react_1.default.createElement(Laptop_1.default, null) }, "Landscape (16:9)")),
            react_1.default.createElement(material_1.Grid, { item: true, xs: 6, md: 3 },
                react_1.default.createElement(material_1.Button, { onClick: openInLandscape43Ratio, variant: "contained", fullWidth: true, size: "large", startIcon: react_1.default.createElement(Laptop_1.default, null) }, "Landscape (4:3)")))));
};
exports.ClientVenuePicker = ClientVenuePicker;
exports.default = exports.ClientVenuePicker;
